import $ from 'jquery'

const VONAGE_API_BRAND = `SilverChef`
const VONAGE_API_ENDPOINT = (window.location.host.includes(`staging`) || window.location.host.includes(`test`)) ?
    `https://staging.silverchef.finance` :
    `https://www.silverchef.finance`
const COUNTRY = window.Shopify.country.toLowerCase()

/**
 * Make fetch API calls
 *
 * @param request_url
 * @param body
 * @param request_method
 * @returns {Promise<any>}
 */
async function apiCall(request_url, body, request_method=`POST`) {
  const response = await fetch(
      request_url,
      {
        method: request_method,
        headers: {
          'Content-Type': `application/json`
        },
        body: JSON.stringify(body)
      }
  )
  if (response.status === 204) {
    return {
      status: 0
    }
  }
  return await response.json()
}

const showLoadingState = () => {
  $(`#smsValidateBtn .sms-loader`).removeClass(`hide`)
  $(`#smsValidateBtn > span`).css(`opacity`, 0)
}

const hideLoadingState = () => {
  $(`#smsValidateBtn .sms-loader`).addClass(`hide`)
  $(`#smsValidateBtn > span`).css(`opacity`, 1)
}

const setValidationButtonText = ctaLabel => {
    $(`#smsValidateBtn > span`).html(`${ctaLabel}`)
}

const cancelCurrentRequestId = async vonageRequestId => {
  // cancel current request id
  const res = await apiCall(`${VONAGE_API_ENDPOINT}/api/sms/${COUNTRY}/cancel/`, {request_id: vonageRequestId})
  
  return res.status === `0`
}

const sendSMSValidation = async number => {
  const apiBrand = VONAGE_API_BRAND
  const vonageRequestId = localStorage.getItem(`vonageRequestId`)

  setValidationButtonText(`Validate Code`)

  $(`#smsResendBtn`).addClass(`disabled`)

  // not allow user retry until 45 sec
  timerStart(45)

  if (vonageRequestId) {
    const clean = await cancelCurrentRequestId(vonageRequestId)

    if (clean) {
      localStorage.removeItem(`vonageRequestId`)
    }
  }

  const errorMsg =
    `Unable to send validation SMS to your phone, please try resend`
  const res = await apiCall(
      `${VONAGE_API_ENDPOINT}/api/sms/${COUNTRY}/verify/`, {
      number: number,
      brand: apiBrand,
      pin_expiry: 300,
      workflow_id: 6,
      lg: `${window.Shopify.locale}`
    })
      .then(res => {
        localStorage.setItem(`vonageRequestId`, res.request_id)
        return true
      })
    .catch(() => {
      displayError(errorMsg)
      return false
    })
}

const timerStart = count => {
  let counter = setInterval(timer, 1000) //1000 will  run it every 1 second

  function timer() {
    if (!checkCanResend()) {
      clearInterval(counter)
      $(`#smsResendBtn`).addClass(`disabled`)
      $(`#smsResendBtn`).html(`Maximum retry time reached`)
      return
    }
    count = count - 1
    if (count <= 0) {
      clearInterval(counter)
      $(`#smsResendBtn`).html(`Didn't get your code?`)
      $(`#smsResendBtn`).removeClass(`disabled`)
      return
    }

    $(`#smsResendBtn`).html(`Didn't get your code? (<span class="transifex-ignore">${count}</span>s)`)
  }
}

const displayError = errorMsg => {
  $(`[data-step="4"] [data-form-errors] p`).html(errorMsg)
  $(`[data-step="4"] [data-form-errors]`).removeClass(`hide`)
}

const hideError = () => {
  $(`[data-step="4"] [data-form-errors]`).addClass(`hide`)
}

const validateAuthCode = async () => {
  const vonageRequestId = localStorage.getItem(`vonageRequestId`)
  const code = $(`#authCodeInput`).val()

  showLoadingState()

  $(`[data-step="4"] [data-form-errors]`).addClass(`hide`)

  if (!vonageRequestId) {
    displayError(`Unable to validate your phone`)
    hideLoadingState()
    return false
  }

  if (!code) {
    displayError(`Please enter authentication code`)
    hideLoadingState()
    return false
  }

  $(`#smsValidateBtn`).addClass(`disabled`)

  const res = await apiCall(`${VONAGE_API_ENDPOINT}/api/sms/${COUNTRY}/check/`, {
      request_id: vonageRequestId,
      code: code,
    })
    .then(res => {
      let validateBtn = $(`#smsValidateBtn`)
      let submitButton = document.getElementById(`applicationSubmit`)
      submitButton.dataset.validSms = `true`
      validateBtn.addClass(`disabled`)
      validateBtn.addClass(`hidden`)
      document.getElementById(`smsResendBtn`).classList.add(`disabled`)
      document.getElementById(`authCodeInput`).classList.add(`disabled`)
      document.getElementById(`authCodeInput`).setAttribute(`disabled`, `true`)
      setValidationButtonText(`Validated!`)
      submitButton.dispatchEvent(new Event(`sms-validated`))
    })
    .catch(err => {
      if (!err) {
        displayError(`Unable to validate your phone`)
        hideLoadingState()
        return false
      }
      if (err.status === 6) {
        displayError(`Please resend the code`)
        hideLoadingState()
        return true
      }

      if (err.status === 16) {
        displayError(`Invalid code`)
        hideLoadingState()
        return false
      }

      if (err.status !== 0) {
        displayError(`Unable to validate your phone`)
        hideLoadingState()
        return false
      }
    })

  hideLoadingState()
}

const retryTimePlusOne = () => {
  let retryTime = localStorage.getItem(`retryTime`)
  if (!retryTime) {
    retryTime = 1
  } else {
    retryTime = retryTime * 1 + 1
  }

  localStorage.setItem(`retryTime`, retryTime)
  return retryTime
}

const resendBtnClickFunc = async formatedPhoneNumber => {
  if (!checkCanResend()) {
    return false
  }

  $(`#smsValidateBtn`).removeClass(`disabled`)

  const sendSuccessfully = await sendSMSValidation(formatedPhoneNumber)

  if (sendSuccessfully) {
    retryTimePlusOne()
  }
  if (!checkCanResend()) {
    $(`#smsResendBtn`).html(`Maximum retry time reached`)
  }
}

const checkCanResend = () => {
  const retryTime = localStorage.getItem(`retryTime`)

  return retryTime < 2
}

const checkCanGoNext = () => {
  const isMobileNumberVerified = $(`[name="IsMobileNumberVerified"]`).val()

  if (isMobileNumberVerified === `true`) {
    return true
  } else {
    const continueClicked = localStorage.getItem(`continue`)
    if (continueClicked === `true`) {
      return true
    } else {
      return false
    }
  }
}

const step4Initial = country => {
  const hiddenPhoneNumberValue = $(`#phone`).val()

  $(`[name="IsMobileNumberVerified"]`).val(false)

  // send SMS when loading page
  sendSMSValidation(hiddenPhoneNumberValue)

  $(`[data-next]`).addClass(`disabled`)

  // bind resend function
  if (checkCanResend()) {
    $(`#smsResendBtn`)
      .off(`click.resend`)
      .on(`click.resend`, () => {
        resendBtnClickFunc(hiddenPhoneNumberValue)
      })
  }

  $(`[data-next]`)
    .off(`click.showError`)
    .on(`click.showError`, () => {
      if (!checkCanGoNext()) {
        const errMsg = `You haven't validate your mobile yet`
        $(`[data-step="4"] [data-form-errors] p`).html(errMsg)
      }
    })

  // bind validation function
  $(`#smsValidateBtn`).removeClass(`disabled`)
  $(`#smsValidateBtn`)
    .off(`click.validate`)
    .on(`click.validate`, () => {
      validateAuthCode()
    })

  localStorage.setItem(`continue`, false)

  // clean message
  $(`[data-step="4"] [data-form-errors]`).addClass(`hide`)
  // reset code section
  $(`.verify-section`).css(`opacity`, `1`)
}

const checkAUSite = () => {
  return window.Shopify.country === `AU`
}

const checkCASite = () => {
  return window.Shopify.country === `CA`
}

const checkNZSite = () => {
  return window.Shopify.country === `NZ`
}
const getStoreCountryCode = () => {
  return window.Shopify.country
}

export {
  step4Initial,
  checkCanGoNext,
  checkAUSite,
  checkCASite,
  checkNZSite,
  getStoreCountryCode,
}
